@if(isLoading) {
  <app-auth/>
}
<router-outlet />
